import { Typography } from '@genial/design-tokens';
import { FinanceEnumsFilterTypeEnum } from '@genial/services/dist/models';

import { StatementOptionQuery } from '../../../../../../../store/customerDetail/stataments/types';

export type Option = { label: string; value: string };
export type SelectableOptionsProps = { title: { default: string; modal: string }; items: Option[] };

export const flexStyle = { gap: 8 };

export const textButtonStyle = {
  fontFamily: Typography['fontfamily.base.semibold'],
  fontSize: Typography['fontsize.md'],
};

export const extractValueSelected = (selectedValues: string[], label: string) => {
  const extractedValues = selectedValues
    .map((item) => {
      if (item.startsWith(label)) {
        const splitted = item.split(':');
        return splitted[splitted.length - 1];
      }
      return null;
    })
    .filter((i) => i !== null);

  return extractedValues[extractedValues.length - 1];
};

export const extractOptionsValues = (
  options: SelectableOptionsProps[],
  filterType?: FinanceEnumsFilterTypeEnum,
  transactionType?: StatementOptionQuery
) => {
  if (!options) {
    return [];
  }

  return options.map((entry) => {
    const { title, items } = entry;
    const firstItem = items[0];

    if (transactionType && transactionType !== 'current-account' && title.modal === 'Tipo') {
      const transactionTypeItem = items.find((item) => item.value === transactionType);
      return `${title.modal}:${transactionTypeItem?.label}:${transactionType}`;
    }

    if (filterType && filterType !== 'LastSevenDays' && title.modal === 'Período') {
      const filterTypeItem = items.find((item) => item.value === filterType);
      return `${title.modal}:${filterTypeItem?.label}:${filterType}`;
    }
    return `${title.modal}:${firstItem.label}:${firstItem.value}`;
  });
};
